import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cached = null;
let pending = null;

export const siteUrl = () => cached || window.location.origin;

export const fetchSiteUrl = () => {
  if (cached) return Promise.resolve(cached);
  pending ||= api.get("/public/content").then(({ data }) => { cached = (data.site_url || window.location.origin).replace(/\/$/, ""); return cached; }).catch(() => window.location.origin);
  return pending;
};

export const useSiteUrl = () => {
  const [u, setU] = useState(siteUrl());
  useEffect(() => { fetchSiteUrl().then(setU); }, []);
  return u;
};

export const siteLabel = (u) => (u || siteUrl()).replace(/^https?:\/\//, "");
